import React, { useState } from "react";
import { Skeleton } from "primereact/skeleton";

interface QuickAccessLoadingProps {
    className?: string;
    count?: number;
}

const QuickAccessLoading: React.FC<QuickAccessLoadingProps> = ({
    className,
    count = 8
}) => {
    const loadingTiles = Array.from({ length: count });

    return (
        <div className="panel_item_container">
            {loadingTiles?.map((_, index) => {
                return (
                    <Skeleton key={index} className={`quick_access_loading_tile ${className ?? ''}`}>
                        <Skeleton className="quick_access_icon_loading" />
                        <Skeleton className="quick_access_title_loading" />
                    </Skeleton>
                )
            })}
        </div>
    )
}

export default QuickAccessLoading;